const PROPERTY_TYPES = {
    OFFICE: 'Oficina',
    COMMERCIAL: 'Comercial',
    INDUSTRIAL: 'Industrial',
    HOUSING: 'Habitacional'
};
export default PROPERTY_TYPES;
